









































































import {
  computed, defineComponent, onMounted, reactive, ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import { getPurchaseOrder, getPurchaseOrderLogs } from '@/api';
import purchaseOrderLogTableOption from '@/table/PurchaseOrder/log';
import receiveLogTableOption from '@/table/PurchaseOrder/log-item';
import receiveMiscLogTableOption from '@/table/PurchaseOrder/log-misc-item';
import usePurchaseOrder from '@/use/usePurchaseOrder';

const Log = defineComponent({
  setup() {
    const { route } = useRouter();
    const refetchQuery = ref(false);
    const purchaseOrder = ref({
      type: 'MATERIALS',
    });
    const formatDate = (val: string) => useFormat.date(val).displayShortThaiDate();

    const pendingSearch = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    const filter = reactive({
      date: undefined,
    });

    function clickDateHandler(date: any) {
      if (filter.date === useFormat.date(date).computerShortDate()) {
        filter.date = undefined;
      } else {
        filter.date = useFormat.date(date).computerShortDate();
      }
      pendingSearch();
    }

    function getLogsResult(data: any) {
      return data.map((elm: any) => ({ ...elm, showItems: false }));
    }
    async function getLogsRequest(fnFilter: any) {
      const result = await getPurchaseOrderLogs(route.value.params.poId, fnFilter);
      return result;
    }

    onMounted(async () => {
      purchaseOrder.value = (await getPurchaseOrder(route.value.params.poId)).data;
    });

    return {
      formatDate,
      purchaseOrder,

      getLogsRequest,
      purchaseOrderLogTableOption,
      receiveMiscLogTableOption,
      refetchQuery,
      getLogsResult,
      filter,

      receiveLogTableOption,
    };
  },
});

export default Log;
